import styled from '@emotion/styled';

const Container = styled.div`
  padding-top: 24px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 17px;
`;

const SubTitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: break-spaces;
`;

const StyledWallet = styled.span`
  color: var(--dk-accent, #06c);
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
  position: relative;
`;

const StyledUnder = styled.div`
  width: 43px;
  height: 8px;
  flex-shrink: 0;
  background-color: rgba(0, 102, 204, 0.12);
  position: absolute;
  bottom: 0;
  left: 0;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: break-spaces;
  align-items: center;
`;

const QRWrapper = styled.div`
  position: relative;
  width: 165px;
  height: 165px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  box-sizing: content-box;
`;

const OverlayBox = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const Corner = styled.div<{
  position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}>`
  position: absolute;
  width: 20px;
  height: 20px;
  border: 3px solid var(--dk-accent, #06c);

  ${(props) =>
    props.position === 'topLeft' &&
    `
    top: 0;
    left: 0;
    border-right: none;
    border-bottom: none;
  `}
  ${(props) =>
    props.position === 'topRight' &&
    `
    top: 0;
    right: 0;
    border-left: none;
    border-bottom: none;
  `}
  ${(props) =>
    props.position === 'bottomLeft' &&
    `
    bottom: 0;
    left: 0;
    border-right: none;
    border-top: none;
  `}
  ${(props) =>
    props.position === 'bottomRight' &&
    `
    bottom: 0;
    right: 0;
    border-left: none;
    border-top: none;
  `}
`;

export {
  Container,
  SubTitle,
  StyledWallet,
  StyledUnder,
  SubContainer,
  QRWrapper,
  OverlayBox,
  Corner,
};
